import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ensureNamespaceLoaded } from "../i18n/lazyNamespaces";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Divider,
  Paper,
  useTheme
} from "@mui/material";
import SetupStepHelp from "./setup/SetupStepHelp";

const EtapaSolicitacoes = ({
  requestTypes,
  handleTipoChange,
  handleSubtipoChange,
  handleAddTipo,
  handleRemoveTipo,
  handleAddSubtipo,
  handleRemoveSubtipo,
  onGenerateRequestTypes,
  isGenerating = false,
  errorMessage,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("onboarding");
  useEffect(() => {
    void ensureNamespaceLoaded("onboarding");
  }, []);

  return (
    <Box sx={{ width: "100%"}}>
      <SetupStepHelp stepKey="requests" />
      <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: theme.palette.primary.main }}>
        🧾 {t("setup.requestsStep.title")}
      </Typography>

      <Typography variant="body1" gutterBottom>
        {t("setup.requestsStep.intro")}
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t("setup.requestsStep.hint")}
      </Typography>

      {errorMessage && (
        <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, border: `1px solid ${theme.palette.warning.light}`, backgroundColor: theme.palette.warning.light + "22" }}>
          <Typography variant="body2" color="warning.main">
            {errorMessage}
          </Typography>
        </Box>
      )}

      {requestTypes.length === 0 && (
        <Box sx={{ mb: 3, display: "flex", flexWrap: "wrap", gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            disabled={isGenerating}
            onClick={onGenerateRequestTypes}
          >
            {isGenerating ? t("setup.requestsStep.generating") : t("setup.requestsStep.generateAi")}
          </Button>
          <Button variant="outlined" onClick={handleAddTipo}>
            {t("setup.requestsStep.addManual")}
          </Button>
        </Box>
      )}

      {requestTypes.map((request, tipoIndex) => (
        <Paper key={tipoIndex} sx={{ mb: 3, p: 2, borderLeft: `5px solid ${theme.palette.primary.main}` }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label={t("setup.requestsStep.rootLabel")}
                value={request.tipo}
                onChange={(e) => handleTipoChange(tipoIndex, e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4} textAlign="right">
              <Button
                variant="outlined"
                color="error"
                onClick={() => handleRemoveTipo(tipoIndex)}
                disabled={requestTypes.length <= 1}
              >
                {t("setup.requestsStep.remove")}
              </Button>
            </Grid>
          </Grid>

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            {t("setup.requestsStep.subtypesHeading")}
          </Typography>

          {request.subtipos.map((subtipo, subtipoIndex) => (
            <Grid container spacing={2} alignItems="center" key={subtipoIndex} mb={1}>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  label={t("setup.requestsStep.subtypeLabel", { n: subtipoIndex + 1 })}
                  value={subtipo}
                  onChange={(e) => handleSubtipoChange(tipoIndex, subtipoIndex, e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => handleRemoveSubtipo(tipoIndex, subtipoIndex)}
                  disabled={request.subtipos.length <= 1}
                >
                  {t("setup.requestsStep.remove")}
                </Button>
              </Grid>
            </Grid>
          ))}

          <Button variant="outlined" onClick={() => handleAddSubtipo(tipoIndex)}>
            {t("setup.requestsStep.addSubtype")}
          </Button>
        </Paper>
      ))}

      {requestTypes.length > 0 && (
        <Box mt={2}>
          <Button variant="contained" onClick={handleAddTipo}>
            {t("setup.requestsStep.addType")}
          </Button>
        </Box>
      )}

      <Typography variant="caption" color="text.secondary" sx={{ mt: 3, display: "block" }}>
        💡 {t("setup.requestsStep.footer")}
      </Typography>
    </Box>
  );
};

export default EtapaSolicitacoes;